/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShoppingCartItemDto } from '../../models/shopping-cart-item-dto';

export interface ShoppingCartControllerGetItems$Params {
  ids: Array<string>;
}

export function shoppingCartControllerGetItems(http: HttpClient, rootUrl: string, params: ShoppingCartControllerGetItems$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShoppingCartItemDto>>> {
  const rb = new RequestBuilder(rootUrl, shoppingCartControllerGetItems.PATH, 'get');
  if (params) {
    rb.query('ids', params.ids, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ShoppingCartItemDto>>;
    })
  );
}

shoppingCartControllerGetItems.PATH = '/api/cart/items';
